import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const accentColor: AdminBlockTypeAttribute = {
  label: 'Show accent color',
  key: 'accentColor',
  inputType: AdminBlockAttributeInputType.COLOR_PICKER,
};

export default accentColor;
